import { render } from "./ProjectSummaryFollow.vue?vue&type=template&id=67cc6b6d"
import script from "./ProjectSummaryFollow.vue?vue&type=script&lang=js"
export * from "./ProjectSummaryFollow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__